import { useCallback } from 'react';

import { fetchLiveSupportMessagesAction } from '../apiActions/fetchLiveSupportMessagesAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useLiveSupportMessagesFetcher = (essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const chatUrl = useConfigSlice.env()?.chat;
  const tableId = useConfigSlice.tableId() ?? '';
  const userId = useConfigSlice.userId() ?? '';

  return useCallback(() => {
    if (chatUrl && tableId && userId) {
      dispatch(
        fetchLiveSupportMessagesAction({
          url: `${chatUrl}/api/fetchMessages`,
          offset: 0,
          recordsPerPage: 100,
          tableId: tableId,
          tagMessage: 'SUPPORT',
          timestamp: Date.now(),
          userId: userId,
          action: 'COMMAND',
          essential,
        })
      );
    }
  }, [chatUrl, tableId, dispatch, userId, essential]);
};
